import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { commonClass } from '../../helpers/commonClass';
import Countdown, { zeroPad } from 'react-countdown';
import { gameActions } from '../../action/GameAction';
import { alertActions } from '../../action/AlertAction';
import { faL } from '@fortawesome/free-solid-svg-icons';

let refecthgamecnt = 0;
let TotalGames = 6;
let lastCountDownTime = Date.now();
class LoadHomeLotto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDrawCompleted: false,
            cartItems: [],
            random: [],
            autoApplyCountmax: 10,//max pad count
            myfavNoID: 0,
            otherGameCount: 0,
            dataFatchCompleted: false,
            ActiveSlider: 1,
            showSaleCloseInfo: false,
            showSaleCloseSuper: false,
            bannerList: [],
            SaleCloseInfoMagic: false,
            SaleCloseInfoDream: false,
            MagicGameId: 0,
            SuperGameId: 0,
            FortuneGameId: 0,
            PrevCartFlag: false,
            SaleCloseInfoLucky: false,
            LuckyGameId: 0,
            myUCDraw: [],
            lottoType: props.lottotype ? props.lottotype : null,
            currentDraw: {},
            padCount: 2,//default pad count
            padCountmax: 31,//max pad count
            CartmaxLength: 50,
            OldcartItems: [],
            showSaleClosePick3: false,
            Pick3GameId: 0,
            UserCountry: localStorage.getItem('cloc') ? JSON.parse(localStorage.getItem('cloc')) : {},
            AllavailGames: [1, 2, 3, 4, 5, 6],
            Datafetch: false
        };
    }

    reCount = (rundraw) => {
        if (rundraw == null || Object.keys(rundraw).length == 0) {
            return <></>;
        }
        else {
            if (this.props.serverTime > 0) {
                this.state.coundownStart = 1;
                return <><Countdown now={() => { return (this.props.serverTime); }} date={this.getGameTime(rundraw)} onComplete={this.countdownCompleted} renderer={this.renderer} /> </>;
            }
            else {
                return <>
                    <><div className="timeCont"><div id="hours1">00</div><p>Hours</p></div><span>:</span></>
                    <><div className="timeCont"><div id="minutes1">00</div><p>Minutes</p></div><span>:</span></>
                    <><div className="timeCont"><div id="seconds1">00</div><p>Seconds</p></div></>
                </>
            }
        }
    };


    getGameTime = (rundraw) => {
        lastCountDownTime = Date.now();
        let _date = rundraw ? rundraw.DrawDateTime : "";
        if (_date != undefined && _date != "") {
            var pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
            let sTime = (new Date(_date.replace(pattern, '$3-$2-$1').replace(/-/g, '/')).getTime());
            //console.log("getGameTime : " + sTime);
            //console.log("DateNow : " + Date.now());

            // if (rundraw.SaleStatus == 0) { //0-open,1-closed  ,Sale closeTime implemented
            let SaleCloseTime = sTime - rundraw.SaleCloseTimeMSec;
            let SaleStatusRemaining = SaleCloseTime - this.props.serverTime;
            let SalesClo = (SaleStatusRemaining > 0 ? 0 : 1);
            if (SalesClo != rundraw.SaleStatus) {
                rundraw.SaleStatus = SalesClo;
                this.state.currentDraw.SaleStatus = SalesClo;
                //Lucky1 Game Current Game Close After Second Game Load 
                if (rundraw.gamegroupID == 13 || rundraw.gamegroupID == 15) {
                    setTimeout(() => {
                        this.reloadNextDraw()
                    }, 1500);
                }
            }
            // }

            // if (this.state.showSaleCloseInfo == false) {
            //     let SaleCloseTime1 = sTime - this.props.serverTime;
            //     this.state.showSaleCloseInfo = SaleCloseTime1 < (24 * (60 * (60 * 1000))) ? true : false;
            // }
            let daysmillis = 86400000; //One day (24 hours)
            if (rundraw.gamegroupID == 1 || (rundraw.gamegroupID == 1 && this.state.FortuneGameId != rundraw.GameId)) {
                if (this.state.showSaleCloseInfo == false) {
                    let SaleCloseTime1 = sTime - this.props.serverTime;
                    this.state.showSaleCloseInfo = SaleCloseTime1 < daysmillis ? true : false;
                }
                this.state.FortuneGameId = rundraw.GameId;
            }
            else if (rundraw.gamegroupID == 3 || (rundraw.gamegroupID == 3 && this.state.MagicGameId != rundraw.GameId)) {
                if (this.state.SaleCloseInfoMagic == false) {
                    let SaleCloseTime1 = sTime - this.props.serverTime;
                    this.state.SaleCloseInfoMagic = SaleCloseTime1 < daysmillis ? true : false;
                }
                this.state.MagicGameId = rundraw.GameId;
            }
            else if (rundraw.gamegroupID == 4 || (rundraw.gamegroupID == 4 && this.state.LockyGameId != rundraw.GameId)) {
                if (this.state.SaleCloseInfoLucky == false) {
                    let SaleCloseTime1 = sTime - this.props.serverTime;
                    this.state.SaleCloseInfoLucky = SaleCloseTime1 < daysmillis ? true : false;
                }
                this.state.LockyGameId = rundraw.GameId;
            }
            else if (rundraw.gamegroupID == 5 || (rundraw.gamegroupID == 5 && this.state.DreamGameId != rundraw.GameId)) {
                if (this.state.SaleCloseInfoDream == false) {
                    let SaleCloseTime1 = sTime - this.props.serverTime;
                    this.state.SaleCloseInfoDream = SaleCloseTime1 < daysmillis ? true : false;
                }
                this.state.DreamGameId = rundraw.GameId;
            }
            else if (rundraw.gamegroupID == 2 || (rundraw.gamegroupID == 2 && this.state.SuperGameId != rundraw.GameId)) {
                if (this.state.showSaleCloseSuper == false) {
                    let SaleCloseTime1 = sTime - this.props.serverTime;
                    this.state.showSaleCloseSuper = SaleCloseTime1 < daysmillis ? true : false;
                }
                this.state.SuperGameId = rundraw.GameId;
            }
            else if (rundraw.gamegroupID == 15 || (rundraw.gamegroupID == 15 && this.state.Pick3GameId != rundraw.GameId)) {
                if (this.state.showSaleClosePick3 == false) {
                    let SaleCloseTime1 = sTime - this.props.serverTime;
                    this.state.showSaleClosePick3 = SaleCloseTime1 < daysmillis ? true : false;
                }
                this.state.Pick3GameId = rundraw.GameId;
            }

            return sTime;
        }
        else {
            return 0;
        }
    };


    reloadNextDraw = () => {
        this.state.myUCDraw = [];
        setTimeout(() => {
            let mythis = this;
            mythis.props.GameAvailableGames(mythis.props.user.mobileNo, 0, mythis.props.i18n.language, mythis.props.serverTime, mythis.props.user.loginKey);
            // Lucky1 GamePad Close Next Draw GamePad Open. 
            setTimeout(() => {
                let latestgame = this.state.currentAvailableDraws.filter(a => a.gamegroupID == this.state.currentDraw.gamegroupID && a.SaleStatus == 0);
                if (latestgame && latestgame.length > 0) {
                    this.setCurrentDraw(latestgame[0])
                }
            }, 1000);
        }, (500));
    }
    renderer = ({ total, days, hours, minutes, seconds, completed }) => {
        let retval
        if (completed) {
            retval = <div className='aftercomplete' >{this.props.t('lblDrawClosed')}</div>;
        } else {
            if (days > 0) {
                retval = <>
                    <><div className="timeCont"><div id="days1">{zeroPad(days)}</div><p>Days</p></div><span>:</span></>
                    <><div className="timeCont"><div id="hours1">{zeroPad(hours)}</div><p>Hours</p></div><span>:</span></>
                    <><div className="timeCont"><div id="minutes1">{zeroPad(minutes)}</div><p>Min</p></div><span>:</span></>
                    <><div className="timeCont"><div id="seconds1">{zeroPad(seconds)}</div><p>Sec</p></div></>
                </>;
            }
            else {
                retval = <>
                    <><div className="timeCont"><div id="hours1">{zeroPad(hours)}</div><p>Hours</p></div><span>:</span></>
                    <><div className="timeCont"><div id="minutes1">{zeroPad(minutes)}</div><p>Min</p></div><span>:</span></>
                    <><div className="timeCont"><div id="seconds1">{zeroPad(seconds)}</div><p>Sec</p></div></>
                </>;
            }
        }
        return retval;
    };
    countdownCompleted = () => {
        //this.RefreshAfterGameClose();        
        this.state.isDrawCompleted = true;
    };


    handleFocus = () => {
        try {
            if (document.visibilityState == "visible") {
                let CtotalGamelen = [...new Set(this.state.currentAvailableDraws.filter(Obj => Obj.SaleStatus == 0).map(item => item.gamegroupID))].length;
                if (!this.state.currentAvailableDraws || CtotalGamelen != TotalGames) {
                    this.props.GameFamily(0, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);//typeID,mobileno,langID
                    setTimeout(() => {
                        refecthgamecnt = 0;
                        this.state.dataFatchCompleted = false;
                    }, 500);
                }
            }
        }
        catch (ex) {
            console.log("document visibilityState", ex)
        }
    }

    static getDerivedStateFromProps(props, state) {
        return {
            currentAvailableDraws: props.currentAvailableDraws,
            MyFavNos: props.MyFavNos,
        }
    }


    componentDidMount() {
        let mythis = this;
        window.addEventListener("visibilitychange", function () { mythis.handleFocus(); })
    };



    componentDidUpdate() {
        // var lstrdata = localStorage.getItem('alertmsg');
        // if (lstrdata != null) {
        //     this.props.alertsucc(lstrdata);
        // }
        this.loadPrevCartItem();
        this.reFetchTheGameData(); // game loading performance changes.

        if (this.props.serverTime && this.props.serverTime > 0 && this.props.firstThreeLotto && this.props.firstThreeLotto == true && this.state.Datafetch == false) {
            if (this.state.currentAvailableDraws && this.state.currentAvailableDraws.length > 0) {
                let Alldraws = this.state.currentAvailableDraws.filter(a => a.gamegroupID >= 1 && a.gamegroupID <= 6)
                let sortedData = [...Alldraws].sort((a, b) => {
                    return this.parseDate(a.DrawDateTime) - this.parseDate(b.DrawDateTime);
                });
                sortedData = sortedData.filter(a => a.gamegroupID != this.state.lottoType)
                let _ggidLst = sortedData && [...new Set(sortedData.map(item => item.gamegroupID))];
                this.setState({ AllavailGames: _ggidLst.slice(0, 3) })
            }
            else {
                this.setState({ AllavailGames: [] })
            }
            this.setState({ Datafetch: true })
            this.state.Datafetch = true
        }
    }

    parseDate = (dateStr) => {
        const [day, month, yearAndTime] = dateStr.split('/');
        const [year, time] = yearAndTime.split(' ');
        return new Date(`${year}-${month}-${day}T${time}`);
    };



    loadPrevCartItem = () => {
        if (this.state.currentAvailableDraws && this.state.currentAvailableDraws.length > 0 && this.state.PrevCartFlag == false) {
            this.state.PrevCartFlag = true;
            let prevCartItem = localStorage.getItem('mycart') && localStorage.getItem('mycart') == '' ? null : JSON.parse(localStorage.getItem('mycart'));
            // window.SetWidthCountDown();
            if (prevCartItem) {
                this.state.otherGameCount = prevCartItem.length;
                return
                this.state.currentAvailableDraws.forEach(_drawEle => {
                    //for get the other game betslip value..                
                    let prevCartItem1 = prevCartItem.filter(a => a.gamegroupID == _drawEle.gamegroupID);
                    if (prevCartItem1 && prevCartItem1.length > 0) {
                        _drawEle.BetSelection = prevCartItem1[0].BetSelection;
                        _drawEle.stakeValue = prevCartItem1[0].stakeValue;
                        this.state.cartItems.push(prevCartItem1[0]);
                    }
                });
            }
        }
    }

    reFetchTheGameData = () => {
        try {
            if (this.state.dataFatchCompleted == false) {
                let CtotalGamelen = [...new Set(this.state.currentAvailableDraws.filter(Obj => Obj.SaleStatus == 0).map(item => item.gamegroupID))].length;
                // this.state.currentAvailableDraws.filter(Obj => Obj.SaleStatus == 0).length
                if ((!this.state.currentAvailableDraws || CtotalGamelen != TotalGames) && refecthgamecnt < 2) {
                    console.log("refecthgamecnt " + refecthgamecnt);
                    let mythis = this;
                    refecthgamecnt++;
                    let regame = setInterval(() => {
                        mythis.props.GameAvailableGames(mythis.props.user.mobileNo, 0, mythis.props.i18n.language, mythis.props.serverTime, mythis.props.user.loginKey);
                        clearInterval(regame)
                    }, (2000 * refecthgamecnt));
                }
                else {
                    this.state.dataFatchCompleted = true;
                    this.setState({ dataFatchCompleted: true });
                    // After game Close Next Game Automatic Fetch. 
                    setTimeout(() => {
                        if (this.state.currentDraw && this.state.currentDraw.SaleStatus != 0) {
                            let setcdraw = this.state.currentAvailableDraws.filter(a => a.gamegroupID == this.state.currentDraw.gamegroupID);
                            if (setcdraw && setcdraw.length > 0) {
                                this.setCurrentDraw(setcdraw[0])
                            }
                        }
                    }, 3000);
                }
                //for multi draw
                if (this.state.currentAvailableDraws && this.state.currentAvailableDraws.length > 0) {
                    if (this.state.myUCDraw && this.state.myUCDraw.length > 0) {
                        //-remove closed draw selection gameID
                        let lst = [];
                        this.state.myUCDraw.forEach(element => {
                            let fobj = this.state.currentAvailableDraws.filter(Obj => Obj.gamegroupID == this.state.currentDraw.gamegroupID && Obj.GameId == element && Obj.SaleStatus != 1);
                            if (fobj && fobj.length > 0) {
                                lst.push(fobj[0])
                            }
                        });
                        this.state.myUCDraw = [lst[0].GameId];
                        //-remove closed draw selection gameID
                    }
                    let fobj = this.state.currentAvailableDraws.filter(Obj => Obj.gamegroupID == this.state.currentDraw.gamegroupID && Obj.SaleStatus == 0);
                    if ((!this.state.myUCDraw || this.state.myUCDraw.length == 0) && fobj.length > 0) {
                        this.state.myUCDraw = [fobj[0].GameId];
                    }
                }
            }
            else if (this.state.currentAvailableDraws && this.state.currentAvailableDraws.length > 0) {
                //default draw selection issue solved
                let fobj = this.state.currentAvailableDraws.filter(Obj => Obj.gamegroupID == this.state.currentDraw.gamegroupID && Obj.SaleStatus == 0);
                if ((!this.state.myUCDraw || this.state.myUCDraw.length == 0) && fobj.length > 0) {
                    this.state.myUCDraw = [fobj[0].GameId];
                }
            }
        }
        catch (ex) {
            console.log("reFetchTheGameData => " + ex)
        }
    };

    GotoLotto = (id) => {
        commonClass.IDPageControl(id)
    }


    render() {
        const { t } = this.props;
        return (
            <>
                {!this.props.firstThreeLotto ? <h2 class="headding1">Lotto Ending Soon</h2> :
                    this.props.firstThreeLotto && this.state.AllavailGames.length > 0 ? <h2 class="headding1">{t('lblotherlotto')}</h2> : <h1></h1>}
                <div className="gameSelctionCont" id='game_all'>
                    {this.state.AllavailGames.map((x1, inx1) => <>
                        {(this.state.currentAvailableDraws && this.state.currentAvailableDraws.filter(a => a.gamegroupID == x1).length > 0) ?
                            this.state.currentAvailableDraws.filter(a => a.gamegroupID == x1).sort((a, b) => parseInt(b.SaleStatus) <= parseInt(a.SaleStatus) ? 1 : -1).slice(0, 1).map((x, inx) =>
                                <div class={`gameSelect lto-${x.gamegroupID}-bg-gradiant`} onClick={() => { this.GotoLotto(x.gamegroupID) }}>
                                    <div className="gameSelectTop">
                                        <div className="gameLogo">
                                            <img src={`./assets/img/gamesBg/${commonClass.IDWiseGameLogo(x.gamegroupID, 'home')}`} alt={`${x.LotName} logo`} />
                                        </div>
                                        <div class="aedMsg">
                                            <p>{this.props.appvariables.currency}&nbsp;{commonClass.aedCrnyConvert(x.minStake, 1)} </p>
                                            {/*{x.LotName}  */}
                                            <h5>{x.DisplayDateTime}<br />{x.DrawShowTime} &nbsp;(UTC)</h5>
                                        </div>
                                    </div>
                                    <div class="prizeAmount">
                                        {process.env.REACT_APP_CURRENCY_NAME} {commonClass.aedCrnyConvert(x.RateInPs)}*
                                    </div>

                                    <div className="drawInfo" >
                                        {(x.SaleCloseTimeMSec > 0 &&
                                            ((this.state.showSaleCloseInfo && x.gamegroupID == 1) ||
                                                (this.state.showSaleCloseSuper && x.gamegroupID == 2) ||
                                                (this.state.SaleCloseInfoMagic && x.gamegroupID == 3) ||
                                                (this.state.SaleCloseInfoLucky && x.gamegroupID == 4) ||
                                                (this.state.SaleCloseInfoDream && x.gamegroupID == 5) ||
                                                (this.state.showSaleClosePick3 && x.gamegroupID == 6))) ?
                                            <>
                                                <span class="drawClosed"></span>
                                                <span class="adjDate animated bounceIn infinite"> {t('lblsalebfr')} {x.SaleCloseTimeMSec / (60 * 1000)} {t('lblminutes')}</span>
                                            </> : <div className="adjDate">&nbsp;</div>
                                            // : <div className={"drawInfo"}></div>
                                        }
                                    </div>
                                    <div class="timeContainer">
                                        <div class="hmDateCont">
                                            <div className="hmDateCoundown">
                                                {this.reCount(x)}
                                            </div>
                                        </div>
                                        <div class="hmDateContPlay">
                                            <a>{t('lblplaynow')}</a>
                                        </div>
                                    </div>

                                </div>
                            ) :
                            <>
                                {
                                    <div class={`gameSelect lto-${x1} lto-${x1}-bg-gradiant`} >
                                        <div class="drawClosed">
                                            {x1 == 1 ? <img src="./assets/img/gamesBg/play-lotto-draw-closed.png?v0.1" alt="draw date" />
                                                : x1 == 2 ? <img src="./assets/img/gamesBg/mini-lotto-draw-closed.png?v0.1" alt="draw date" />
                                                    : x1 == 3 ? <img src="./assets/img/gamesBg/fast-lotto-draw-closed.png?v0.1" alt="draw date" />
                                                        : x1 == 4 ? <img src="./assets/img/gamesBg/millionaire-lotto-draw-closed.png?v0.1" alt="draw date" />
                                                            : x1 == 5 ? <img src="./assets/img/gamesBg/multimillion-lotto-draw-closed.png?v0.1" alt="draw date" />
                                                                : <img src="./assets/img/gamesBg/supermegamillion-lotto-draw-closed.png?v0.1" alt="draw date" />
                                            }
                                            {this.state.currentAvailableDraws && this.state.currentAvailableDraws.length > 0 && this.state.dataFatchCompleted ?
                                                <div class="drawStatus">{t('lblDrawClosed')}..</div>
                                                : <div class="drawStatus">{t('lblLoading')}..</div>}
                                        </div>
                                    </div>
                                }
                            </>
                        }</>
                    )}
                </div>
            </>
        );
    }
}
function mapStateToProps(state) {
    const { currentDraw, MyFavNos, previousCartItem, currentAvailableDraws } = state.gameReducer;//currentAvailableDraws // game loading performance changes.
    const { user, appvariables } = state.loginReducer;
    const { serverTime } = state.commonReducer;
    const { alertReducer } = state;
    return { user, serverTime, currentDraw, MyFavNos, appvariables, previousCartItem, alertReducer, currentAvailableDraws };
}
const mapActionToProps = {
    GameAvailableGames: gameActions.GameAvailableGames,
    GameFamily: gameActions.GameFamily,
    alertsucc: alertActions.success,
}

export default connect(mapStateToProps, mapActionToProps)(withTranslation()(LoadHomeLotto))